module.exports = __webpack_public_path__ + "img/banner.c6fcb81f.png";